import React from "react";
import { Pagination, PaginationProps } from "antd";
import styled from "styled-components";

interface Props extends PaginationProps {
  currentPage: number;
  pageSize: number;
  totalCount: number;
  setCurrentPage: (page: number) => void;
}

const PaginationComponent: React.FC<Props> = ({
  currentPage,
  pageSize,
  totalCount,
  setCurrentPage,
  ...rest
}) => {
  const handleCurrentPage = (page: number) => {
    setCurrentPage(page);
  };
  return (
    <StyledPagination
      current={currentPage}
      pageSize={pageSize}
      total={totalCount}
      size="default"
      showSizeChanger={false}
      onChange={(e) => handleCurrentPage(e)}
      {...rest}
    />
  );
};

const StyledPagination = styled(Pagination)`
  .ant-pagination-item {
    border-radius: 4px;
  }
  .ant-pagination-item-link {
    border-radius: 4px;
    border: none;
  }
`;

export default PaginationComponent;
